export function getState(checked) {
  if (isIndeterminate(checked)) {
    return 'indeterminate'
  }
  if (checked) {
    return 'checked'
  }
  return 'unchecked'
}

export function isIndeterminate(checked) {
  return checked === 'indeterminate'
}
